module.exports = __webpack_public_path__ + "img/hy_mrqhl.53f1ef2c.svg";